/*
  Make Judge.me's star badge on a product page lead somewhere.

  By default the badge scrolls the page down to Judge.me's review widget. Where that widget is
  not on the page there is nothing to scroll to, so the stars read as a control that does
  nothing. This sends them to the reviews page instead.

  It only acts when there is no review widget to scroll to, so if the Review widget is ever
  added to the product template this stands aside and Judge.me's own behaviour returns. No
  change needed here either way.

  The link is a real anchor laid over the badge rather than a click handler, so it can be
  tabbed to, opened in a new tab and read by a screen reader. Judge.me re-renders its badge
  after loading, which removes anything added beforehand, so this watches for that.
*/
(function () {
  var TARGET = '/pages/reviews';
  var MARK = 'btfBadgeLinked';

  function widgetPresent() {
    // Judge.me's own review list, under any of the names it has shipped.
    return !!document.querySelector(
      '.jdgm-review-widget, .jdgm-rev-widg, [data-widget="review-widget"], .jdgm-all-reviews-widget-v2025'
    );
  }

  function link() {
    if (widgetPresent()) return;

    for (const badge of document.querySelectorAll('.jdgm-preview-badge')) {
      if (badge.dataset[MARK] === '1') continue;
      // Judge.me hides the badge on a product with no reviews, collapsing it to nothing. Skip
      // those without marking them done, so a badge still being drawn is picked up next pass.
      if (!badge.getClientRects().length) continue;
      if (!badge.textContent.trim()) continue;
      // Judge.me can also place a badge inside a product card, which is already a link to the
      // product. An anchor inside an anchor is invalid and would hijack the card's own click.
      if (badge.closest('a')) continue;
      badge.dataset[MARK] = '1';

      if (getComputedStyle(badge).position === 'static') badge.style.position = 'relative';

      var a = document.createElement('a');
      a.className = 'btf-badge-link';
      a.href = TARGET;
      a.setAttribute('aria-label', 'Read all customer reviews');
      a.style.cssText =
        'position:absolute;inset:0;z-index:1;display:block;text-indent:-9999px;overflow:hidden;';
      badge.appendChild(a);
    }
  }

  function start() {
    link();
    // Judge.me draws its badge after its script loads, and redraws on variant changes.
    var observer = new MutationObserver(function () {
      link();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Stop watching once the page has settled; the badge does not change after that.
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
